import { isIntranetPath } from "../../../lib/routing";

export const HideIfIntranet = ({ children }) => {
  const isIntranet = isIntranetPath();
  return isIntranet ? null : children;
};
